import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../helpers";

export const ProtectRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = useAuth();
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <div>
            <Component {...props} />
          </div>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};
